import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  BASE_URL,
  NEW_CUSTOMER_REPORT,
  NEW_CUSTOMER_REPORT_COUNT,
} from "../../../Constants/Config";
import { useAuthDetails } from "../../../Common/cookiesHelper";

let abortController = null;

const initialState = {
  loading: false,
  newCustomerreportData: [],
  successMessage: "",
  error: "",

  countLoading: false,
  countData: 10,
};

// Generate pending, fulfilled, and rejected action types
export const fetchnewCustomerreportData = createAsyncThunk(
  "newCustomerreport/fetchnewCustomerreportData",
  async (data, { rejectWithValue }) => {
    if (abortController) {
      abortController.abort(); // Cancel the previous request if it exists
    }

    // Create a new AbortController instance for the current request
    abortController = new AbortController();
    const signal = abortController.signal;

    const { userTypeData } = useAuthDetails();
    try {
      const { token, ...otherUserData } = userTypeData;
      const response = await axios.post(
        BASE_URL + NEW_CUSTOMER_REPORT,
        { ...data, ...otherUserData },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          signal, // Pass the signal to allow cancellation
        }
      );
      if (response.data.status == "Success") {
        return response.data.result;
      } else if (
        response.data.status == "Failed" &&
        response.data.msg == "No. Data found."
      ) {
        return response.data;
      }
    } catch (error) {
      if (error.name == "AbortError") {
        // Handle the cancellation case
        return rejectWithValue({ message: "Request canceled" });
      }

      const customError = {
        message: error.message,
        status: error.response ? error.response.status : "Network Error",
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

// Generate pending, fulfilled, and rejected action types for count
export const fetchnewCustomerreportDataCount = createAsyncThunk(
  "products/fetchnewCustomerreportDataCount",
  async (payload, { rejectWithValue }) => {
    const { token, ...dataNew } = payload;
    try {
      const response = await axios.post(
        BASE_URL + NEW_CUSTOMER_REPORT_COUNT,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.data?.status) {
        return response?.data?.total_count;
      }
    } catch (error) {
      const customError = {
        message: error.message,
        status: error.response ? error.response.status : "Network Error",
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const newCustomerReportSlice = createSlice({
  name: "newCustomerreport",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchnewCustomerreportData.pending, (state) => {
      state.loading = true; // Set loading to true when a new request is initiated
      console.log("state.loading", state.loading);
    });
    builder.addCase(fetchnewCustomerreportData.fulfilled, (state, action) => {
      state.loading = false;
      state.newCustomerreportData = action.payload;
      state.error = "";
    });
    builder.addCase(fetchnewCustomerreportData.rejected, (state, action) => {
      console.log("Rejected action:", action);
      // state.loading = false;
      // state.newCustomerreportData = {};
      // state.error = action.error.message;
      if (action.payload && action.payload.message == "canceled") {
        // If the request was canceled, don't change loading state
        state.error = "Request was canceled";
        // Optionally, keep the data intact or reset it if needed
        // state.newCustomerreportData = []; // Uncomment if you want to reset data on cancel
      } else {
        // For other errors, set loading to false and handle the error
        state.loading = false;
        state.newCustomerreportData = [];
        state.error = action.payload
          ? action.payload.status || action.error.message
          : "Network Error";
      }
    });

    builder.addCase(fetchnewCustomerreportDataCount.pending, (state) => {
      state.countLoading = true;
      state.countData = [];
    });
    builder.addCase(
      fetchnewCustomerreportDataCount.fulfilled,
      (state, action) => {
        state.countLoading = false;
        state.countData = action.payload;
      }
    );
    builder.addCase(
      fetchnewCustomerreportDataCount.rejected,
      (state, action) => {
        state.countLoading = false;
        state.countData = [];
      }
    );
  },
});

export default newCustomerReportSlice.reducer;
